module.exports = __webpack_public_path__ + "img/首页公司简介1.4213c4f0.jpg";